import React, { useRef, useState } from "react";
import "./css/NfcSupport.css";
import { Link } from "react-router-dom";
import ConfirmationModal from "../components/ConfirmationModal";

const quickChecks = [
    {
        id: 1,
        icon: "📱",
        title: "NFC ativado no celular do cliente?",
        description: "Na maioria dos Android, o NFC fica em Configurações > Conexões. No iPhone (XS ou mais novo), o NFC já vem ativado por padrão para leitura.",
    },
    {
        id: 2,
        icon: "📍",
        title: "Encostou na área certa do cartão?",
        description: "O chip NFC fica concentrado em um ponto específico do cartão ou placa. Tente encostar em cantos e regiões diferentes por 1-2 segundos.",
    },
    {
        id: 3,
        icon: "🧲",
        title: "Case ou capinha grossa no celular?",
        description: "Capinhas muito grossas, com metal ou carteira embutida podem bloquear o sinal NFC. Peça para o cliente remover a capa e tentar novamente.",
    },
    {
        id: 4,
        icon: "🔄",
        title: "Já reiniciou o celular do cliente?",
        description: "Um simples reiniciar resolve boa parte dos casos em que o NFC parou de responder temporariamente.",
    },
];

const supportTopics = [
    { value: "Cartão não funciona", label: "Meu cartão/placa não está funcionando" },
    { value: "Trocar link de destino", label: "Quero trocar o link de destino" },
    { value: "Cartão danificado ou perdido", label: "Cartão danificado ou perdido — preciso de reposição" },
    { value: "Pedido de novo cartão", label: "Quero pedir mais cartões/placas" },
    { value: "Dúvida geral", label: "Tenho uma dúvida geral" },
];

const NfcSupport = () => {
    const formRef = useRef();
    const [status, setStatus] = useState(null);

    const sendEmail = async (e) => {
        e.preventDefault();

        const formData = new FormData(formRef.current);
        const data = Object.fromEntries(formData.entries());
        data.reason = `Suporte NFC: ${data.reason}`;

        try {
            const response = await fetch("https://website-backend-production-2163.up.railway.app/api/email/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                setStatus("success");
                formRef.current.reset();
            } else {
                setStatus("error");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            setStatus("error");
        }
    };

    return (
        <section className="nfcs-section">
            <Link to="/nfc-reviews" className="nfcs-home-button">← Voltar</Link>

            <div className="nfcs-hero">
                <span className="nfcs-badge">🛟 Central de Suporte</span>
                <h1 className="nfcs-title">Suporte para Cartões e Placas NFC</h1>
                <p className="nfcs-subtitle">
                    Estamos aqui para garantir que seu cartão de avaliações funcione sempre.
                    Confira as soluções rápidas abaixo ou fale diretamente comigo — respondo
                    pessoalmente todos os pedidos de suporte.
                </p>
                <div className="nfcs-trust-row">
                    <div className="nfcs-trust-pill">
                        <i className="bi bi-clock-history"></i> Resposta em até 24h úteis
                    </div>
                    <div className="nfcs-trust-pill">
                        <i className="bi bi-person-check-fill"></i> Suporte direto comigo
                    </div>
                    <div className="nfcs-trust-pill">
                        <i className="bi bi-shield-check"></i> Sem custo para ajustes de link
                    </div>
                </div>
            </div>

            <div className="nfcs-container">
                <h2 className="nfcs-section-title">Antes de pedir suporte, tente isso</h2>
                <p className="nfcs-section-note">
                    A maioria dos casos de "não está funcionando" se resolve em segundos com uma dessas verificações.
                </p>
                <div className="nfcs-checks-grid">
                    {quickChecks.map((check) => (
                        <div className="nfcs-check-card" key={check.id}>
                            <div className="nfcs-check-icon">{check.icon}</div>
                            <h3 className="nfcs-check-title">{check.title}</h3>
                            <p className="nfcs-check-description">{check.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="nfcs-container">
                <h2 className="nfcs-section-title">Ainda com problema?</h2>
                <p className="nfcs-section-note">
                    Preencha o formulário abaixo com os detalhes do seu caso. Quanto mais informação, mais rápido eu consigo te ajudar.
                </p>

                <div className="nfcs-contact-box" id="nfcs-contact">
                    <form ref={formRef} className="nfcs-contact-form" onSubmit={sendEmail}>
                        <input type="text" name="name" placeholder="Seu nome" required />
                        <input type="email" name="user_email" placeholder="Seu e-mail" required />
                        <input type="text" name="business" placeholder="Nome do estabelecimento" />

                        <select name="reason" required defaultValue="">
                            <option value="" disabled>Qual o motivo do contato?</option>
                            {supportTopics.map((topic) => (
                                <option key={topic.value} value={topic.value}>{topic.label}</option>
                            ))}
                        </select>

                        <textarea
                            name="message"
                            placeholder="Descreva o que está acontecendo (ex: modelo de celular do cliente, onde comprou o cartão, quando começou o problema)..."
                            rows="5"
                            required
                        ></textarea>

                        <button type="submit">Enviar Pedido de Suporte</button>
                    </form>
                </div>

                <div className="nfcs-direct-contact">
                    <p>Prefere falar direto?</p>
                    <a href="mailto:flppprojects@outlook.com" className="nfcs-direct-link">
                        <i className="bi bi-envelope-fill"></i> flppprojects@outlook.com
                    </a>
                </div>
            </div>

            <div className="nfcs-container nfcs-guarantee">
                <div className="nfcs-guarantee-box">
                    <span className="nfcs-guarantee-icon">✓</span>
                    <div>
                        <h3>Compromisso de qualidade</h3>
                        <p>
                            Todo cartão passa por teste de leitura antes do envio. Se o problema for de fabricação
                            do chip, a reposição é feita sem custo adicional para você.
                        </p>
                    </div>
                </div>
            </div>

            <ConfirmationModal
                status={status}
                onClose={() => setStatus(null)}
                onContinue={() => setStatus(null)}
            />
        </section>
    );
};

export default NfcSupport;
